var render, staticRenderFns
import script from "./HKLSearchButton.vue?vue&type=script&lang=js&"
export * from "./HKLSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d487b6')) {
      api.createRecord('29d487b6', component.options)
    } else {
      api.reload('29d487b6', component.options)
    }
    
  }
}
component.options.__file = "src/controls/Button/HKLSearchButton.vue"
export default component.exports